import React from "react";
import Logo from "assets/Logo/1.svg";
import { useDispatch } from "react-redux";
import { handleCloseSidebar } from "store/sidebarReducer/sidebarSlice";
const SidebarLogo = () => {
	const dispatch = useDispatch()
	const closeSidebar = () => {
		dispatch(handleCloseSidebar())
	}
	return (
		<div className="admin-sidebar-title flex items-center bg-primary w-full h-60px">
			<div className="admin-sidebar-hambuger px-5 flex items-end w-full">
				<div className="icon flex cursor-pointer text-white" onClick={closeSidebar}>
					<em className="fa-solid fa-bars text-2xl leading-none"></em>
				</div>
				<div className="logo ml-10px">
					<a href="/">
						<img className="w-180px inline-block" srcSet={`${Logo} 2x`} alt="" />
					</a>
				</div>
			</div>
		</div>
	);
};

export default SidebarLogo;
